var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 6.54545C10.1658 6.54545 10.7084 6.31559 11.1085 5.90641C11.5086 5.49724 11.7333 4.94229 11.7333 4.36364C11.7333 3.94909 11.6267 3.56727 11.424 3.24L9.6 0L7.776 3.24C7.57333 3.56727 7.46667 3.94909 7.46667 4.36364C7.46667 5.56364 8.42667 6.54545 9.6 6.54545ZM14.5067 17.4436L13.3653 16.2764L12.2133 17.4436C10.8267 18.8618 8.39467 18.8727 6.99733 17.4436L5.856 16.2764L4.69333 17.4436C4 18.1527 3.072 18.5455 2.09067 18.5455C1.312 18.5455 0.597333 18.2945 0 17.88V22.9091C0 23.5091 0.48 24 1.06667 24H18.1333C18.72 24 19.2 23.5091 19.2 22.9091V17.88C18.6027 18.2945 17.888 18.5455 17.1093 18.5455C16.128 18.5455 15.2 18.1527 14.5067 17.4436ZM16 9.81818H10.6667V7.63636H8.53333V9.81818H3.2C1.42933 9.81818 0 11.28 0 13.0909V14.7709C0 15.9491 0.938667 16.9091 2.09067 16.9091C2.64533 16.9091 3.17867 16.6909 3.56267 16.2873L5.84533 13.9636L8.11733 16.2873C8.90667 17.0945 10.2827 17.0945 11.072 16.2873L13.3547 13.9636L15.6267 16.2873C16.0213 16.6909 16.544 16.9091 17.0987 16.9091C18.2507 16.9091 19.1893 15.9491 19.1893 14.7709V13.0909C19.2 11.28 17.7707 9.81818 16 9.81818Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthIcon);
export default __webpack_public_path__ + "static/media/birth-icon.92a455f61f7bd5e212e9f69715f28688.svg";
export { ForwardRef as ReactComponent };